var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 16.375H17.364L12.1845 1.48633C12.0908 1.21656 11.9155 0.982666 11.6828 0.817115C11.4501 0.651565 11.1716 0.562574 10.886 0.5625H9.11399C8.82851 0.562512 8.55012 0.651377 8.31744 0.816765C8.08475 0.982153 7.90932 1.21586 7.81547 1.48547L2.63602 16.375H1.0625C0.880164 16.375 0.705295 16.4474 0.576364 16.5764C0.447433 16.7053 0.375 16.8802 0.375 17.0625C0.375 17.2448 0.447433 17.4197 0.576364 17.5486C0.705295 17.6776 0.880164 17.75 1.0625 17.75H18.9375C19.1198 17.75 19.2947 17.6776 19.4236 17.5486C19.5526 17.4197 19.625 17.2448 19.625 17.0625C19.625 16.8802 19.5526 16.7053 19.4236 16.5764C19.2947 16.4474 19.1198 16.375 18.9375 16.375ZM7.20102 7.4375H12.799L14.2341 11.5625H5.76586L7.20102 7.4375ZM9.11399 1.9375H10.886L12.3203 6.0625H7.67969L9.11399 1.9375ZM5.28805 12.9375H14.712L15.9082 16.375H4.0918L5.28805 12.9375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorn);
export default __webpack_public_path__ + "static/media/icon-corn.3252e031e018754d70396cc9ec55142a.svg";
export { ForwardRef as ReactComponent };